import { useRef, useEffect, useState } from 'react';
import { Button } from '@quyva/shared-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWrench, faPlus } from '@fortawesome/free-solid-svg-icons';
import { toSentenceCase } from '@quyva/common';

export default function ToolsListCollection({
    tools,
    selectedToolId,
    onSelectTool,
    onAddInstance,
}) {
    const actionToolRef = useRef(null);
    const [toolWithAction, setToolWithAction] = useState(null);

    useEffect(() => {
        if (actionToolRef.current && toolWithAction) {
            actionToolRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    }, [toolWithAction]);

    return tools.map((toolItem, index) => (
        <div
            key={toolItem.id}
            ref={
                toolWithAction && toolWithAction.id === toolItem.id
                    ? actionToolRef
                    : null
            }
            className="w-full text-texts-secondary300"
        >
            <button
                className={`w-full h-full flex items-center justify-between py-0.5 px-2 border border-transparent hover:bg-backgrounds-primary100 hover:border hover:border-backgrounds-primary200 text-base ${
                    selectedToolId === toolItem.id
                        ? 'bg-backgrounds-primary100 hover:border-backgrounds-primary200 shadow-inner'
                        : ''
                } rounded-xl my-2`}
                onClick={(e) => {
                    onSelectTool(toolItem.id);
                    setToolWithAction(toolItem);
                }}
            >
                {/* Left side: icon + name */}
                
                <div className="h-full flex items-center justify-center truncate">
                    <div className='w-8 h-8 rounded-full bg-white flex items-center justify-center mr-1'>
                    <FontAwesomeIcon
                        
                        icon={faWrench}
                        className={`drop-shadow-sm fa-sm ${
                            selectedToolId === toolItem.id
                                ? 'text-backgrounds-primary300'
                                : 'text-icons-primary'
                        }`}
                    />
                    </div>
                    <div
                        className="h-full flex items-center truncate"
                        title={toolItem.name}
                    >
                        <span
                            className={`truncate text-base ${
                                selectedToolId === toolItem.id
                                    ? 'text-backgrounds-primary300'
                                    : ''
                            }`}
                        >
                            {toSentenceCase(toolItem.name)}
                        </span>
                    </div>
                </div>

                {/* Right side: add instance button */}
                <div className="flex items-center justify-center">
                    <Button
                        size="xs"
                        variant="ghost"
                        onClick={(e) => {
                            e.stopPropagation();
                            onAddInstance(toolItem.id === 'all' ? null : toolItem);
                        }}
                        hoverText="Add Instance"
                        icon={faPlus}
                        type="success" 
                        className={`w-8 h-8 ${
                            selectedToolId === toolItem.id
                                ? 'text-backgrounds-primary300'
                                : 'text-icons-primary'
                        }`}
                    />
                </div>
            </button>
        </div>
    ));
}
